import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faRightFromBracket,
  faCircleCheck,
  faShop,
  faLocationDot,
  faUsers,
  faUser,
  faStar,
  faBullhorn,
  faUtensils,
  faCalendar,
  faFilter,
  faBars,
  faFileContract,
  faMoneyBill,
  faCoins,
  faCircle,
  faCalendarDays,
  faFlag,
  faVenusMars,
  faPhone,
  faEnvelope,
  faRing,
  faUniversity,
  faChevronDown,
  faStore,
  faTrash,
  faRotateRight,
  faFilterCircleXmark,
  faSign,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

  import {
    faUser as faUserRegular,
    faBriefcase,
    faPaperPlane,
    faCalendarClock,
    faBell,
    faComments,
    faBuilding,
    faBullhorn as faMegaphone,
    faInboxIn,
    faUserMagnifyingGlass,
    faF,
    faInstagram,
    faLinkedin,
    faYoutube,
  } from "@fortawesome/pro-solid-svg-icons";
  import {faCircleCheck as faCircleCheckRegular, faXmarkCircle as faXmarkRegular} from '@fortawesome/pro-regular-svg-icons';

import {
  faTimer,
  faHatChef,
  faUserChef,
  faUserGroupSimple,
  faAddressBook,
  faSliders,
  faSignOut,
} from '@fortawesome/pro-solid-svg-icons';

export const checkIcon = <FontAwesomeIcon icon={faCircleCheck} style={{color: "#000000", width: "20px", height:"20px"}} />
export const circleIcon = <FontAwesomeIcon icon={faCircle} style={{color: "#fb5424", width: "20px", height:"20px"}} />
export const checkOrangeIconRegular = <FontAwesomeIcon icon={faCircleCheckRegular} style={{color: "#fb5424", width: "20px", height:"20px"}} />
export const xOrangeIcon = <FontAwesomeIcon icon={faXmarkRegular} style={{color: "#fb5424", width: "20px", height:"20px"}} />
export const checkOrangeIcon = <FontAwesomeIcon icon={faCircleCheck} style={{color: "#fb5424", width: "20px", height:"20px"}} />
export const shopIcon = <FontAwesomeIcon icon={faShop} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const restaurantType = <FontAwesomeIcon icon={faShop} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const locationIcon = <FontAwesomeIcon icon={faLocationDot} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const usersIcon = <FontAwesomeIcon icon={faUsers}  style={{color: "#fb5424", width: "1rem", height: "1rem"}}/>
export const starIcon = <FontAwesomeIcon icon={faStar} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const starLightIcon = <FontAwesomeIcon icon="fa-regular fa-star" style={{color: "#fb5424", width: "1rem", height: "1rem"}}/>
export const timerIcon = <FontAwesomeIcon icon={faTimer} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const contractIcon = <FontAwesomeIcon icon={faFileContract} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const chefHatIcon = <FontAwesomeIcon icon={faHatChef} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const bullHornIcon = <FontAwesomeIcon icon={faBullhorn} style={{color: "#fb5424", width: "2rem", height: "2rem"}} />;
export const utensilsIcon = <FontAwesomeIcon icon={faUtensils} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const scheduleIcon = <FontAwesomeIcon icon={faCalendar} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const filterIcon = <FontAwesomeIcon icon={faSliders} style={{color: "#fb5424", width: "1.5rem", height: "1.5rem"}}/>
export const barsIcons = <FontAwesomeIcon icon={faBars} style={{color: "#fb5424", width: "1.5rem", height: "1.5rem"}}/>
export const userChefIcon = <FontAwesomeIcon icon={faUserChef} style={{color: "#fb5424", width: "1rem", height: "1rem"}}/>
export const moneyIcon = <FontAwesomeIcon icon={faMoneyBill} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const coinIcon = <FontAwesomeIcon icon={faCoins} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const clientsIcon = <FontAwesomeIcon icon={faUserGroupSimple} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const birthDayIcon = <FontAwesomeIcon icon={faCalendarDays} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const flagIcon = <FontAwesomeIcon icon={faFlag} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const genreIcon = <FontAwesomeIcon icon={faVenusMars} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const phoneIcon = <FontAwesomeIcon icon={faPhone} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const emailIcon = <FontAwesomeIcon icon={faPhone} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const envelopeIcon = <FontAwesomeIcon icon={faEnvelope} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const ringIcon = <FontAwesomeIcon icon={faRing} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const universityIcon = <FontAwesomeIcon icon={faUniversity} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const applicantsIcon = <FontAwesomeIcon icon={faAddressBook} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const downArrowIcon = <FontAwesomeIcon icon={faChevronDown} style={{color: "#fb5424", width: "0.5rem", height: "0.5rem", marginLeft:"0.5rem"}} />;
export const storeIcon = <FontAwesomeIcon icon={faStore} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const trashIcon = <FontAwesomeIcon icon={faTrash} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;
export const refreshIcon = <FontAwesomeIcon icon={faFilterCircleXmark} style={{color: "#fb5424", width: "1.5rem", height: "1.5rem"}} />;
export const avatarIcon = <FontAwesomeIcon icon={faUser} style={{color: "#fb5424", width: "1.5rem", height: "1.5rem"}} />;
export const signOutIcon = <FontAwesomeIcon icon={faSignOut} style={{color: "#fb5424", width: "1rem", height: "1rem"}} />;


export const userIcon = <FontAwesomeIcon icon={faUser} style={{ color: "#fb5424", width: "1.2rem", height: "1.2rem" }} />
export const briefcaseIcon = <FontAwesomeIcon icon={faBriefcase} style={{ color: "#fb5424", width: "1.2rem", height: "1.2rem" }} />
export const paperPlaneIcon = <FontAwesomeIcon icon={faPaperPlane} style={{ color: "#fb5424", width: "1.2rem", height: "1.2rem" }} />
export const calendarClockIcon = <FontAwesomeIcon icon={faCalendarClock} style={{ color: "#fb5424", width: "1.2rem", height: "1.2rem" }} />
export const bellIcon = <FontAwesomeIcon icon={faBell} style={{ color: "#fb5424", width: "1.2rem", height: "1.2rem" }} />
export const commentsIcon = <FontAwesomeIcon icon={faComments} style={{ color: "#fb5424", width: "1.2rem", height: "1.2rem" }} />

// Companies
export const buildingIcon = <FontAwesomeIcon icon={faBuilding} style={{ color: "#fb5424", width: "1.2rem", height: "1.2rem" }} />
export const megaphoneIcon = <FontAwesomeIcon icon={faMegaphone} style={{ color: "#fb5424", width: "1.2rem", height: "1.2rem" }} />
export const inboxIcon = <FontAwesomeIcon icon={faInboxIn} style={{ color: "#fb5424", width: "1.2rem", height: "1.2rem" }} />
export const userMagnifyingGlassIcon = <FontAwesomeIcon icon={faUserMagnifyingGlass} style={{ color: "#fb5424", width: "1.2rem", height: "1.2rem" }} />


export const iconMapping = {
    contrato: contractIcon,
    disponibilidad: scheduleIcon,
    vacantes: usersIcon,
    propinas: coinIcon,
    establecimiento: shopIcon,
    ubicación: locationIcon,
    ostulantes: usersIcon,
    oferta_publicada: scheduleIcon,
    sueldo: moneyIcon,
    especialidad:utensilsIcon,
    locales:storeIcon,
    clientes_semanales:clientsIcon,
    trabajadores:userChefIcon,
    fecha_de_nacimiento:birthDayIcon,
    experiencia:starIcon,
    nacionalidad: flagIcon,
    género: genreIcon,
    email: envelopeIcon,
    nacimiento: birthDayIcon,
    teléfono: phoneIcon,
    jornada: timerIcon,
    estado_civil:ringIcon,
    postulantes: usersIcon,
}
